/*jslint esnext: true */
/*global jQuery, dis, Modernizr */

/* DIS/PLAY Script
 Author's name: Anders Gissel
 Modified by:
 Client name: Hørsholm municipality
 Date of creation: Dec. 16th, 2015
 */


(function ($, dis) {
	"use strict";


	/**
	 * This module handles the header and whatever
	 *
	 * @param objectConfiguration - The configuration for the object
	 * @param {jQuery|HTMLElement|string|*} objectConfiguration.container - The DOM-container for this instantiation
	 * @constructor
	 * @extends dis.BaseModule
	 */
	dis.ui.Header = function (objectConfiguration) {

		// Fire the basemodule-initiator on this module.
		dis.BaseModule.call(this);

		var defaults = {},
			configuration = $.extend(defaults, objectConfiguration),
			dom = {},
			helpers,
			eventHandlers,
			lastScrollPosition = 0,
			initComplete = false,
			selfScope = this,
			menuItemsInMainMenu;



		helpers = {

			/**
			 * Enable or disable the page scroll-lock based on the given checkbox's state
			 *
			 * @param {jQuery|HTMLElement|string|*} targetCheckbox
			 * @param {boolean} [showMenuOnDisengage]
			 * @returns {boolean}
			 */
			setScrolllockDependingOnCheckboxState: function (targetCheckbox, showMenuOnDisengage) {
				var target = $(targetCheckbox),
					isChecked = target.prop("checked");

				if (isChecked) {
					// Enable scroll-lock on body
					selfScope.scrollLock.enable();
				} else {
					// Blur the toggle-checkbox after 100ms. This removes "visual focus" from the button.
					if (showMenuOnDisengage) {
						// Hack-forcing the menu to appear. Because that's how we do!
						lastScrollPosition = 99999999;
					}

					// Disable scroll-lock on body
					selfScope.scrollLock.disable();
				}

				return isChecked;
			}
		};

		eventHandlers = {

			/**
			 * Add or remove the "scroll-state" class on our header container, based on whether or not our scroll
			 * position is at least 100px from the page top. This allows us to do stuff to the menu using pure CSS.
			 */
			onScrollEvent: function () {

				// Only continue if the scroll lock isn't active
				if (!selfScope.scrollLock.state()) {

					var limitAtWhichWeShouldHideTheTopMenu = selfScope.currentScreenMode >= selfScope.screenSizes.tablet ? 200 : 140,
						scrollingActive;

					scrollingActive = (selfScope.currentWindowScrollPositionY >= limitAtWhichWeShouldHideTheTopMenu &&
							selfScope.currentWindowScrollPositionY > lastScrollPosition);

					dom.container
						.toggleClass("scroll-state", scrollingActive)
						.toggleClass("no-scroll-state", !scrollingActive);

					lastScrollPosition = selfScope.currentWindowScrollPositionY;
				}

			},


			/**
			 * This function fixes the side menu height on browsers that do not support the VH unit natively.
			 * Oh, and also on Safari on iOS, since that piece of crap software has a mind of its own.
			 */
			fixSidemenuHeight: function () {
				if (selfScope.currentScreenMode >= selfScope.screenSizes.tablet) {
					dom.headerMenu.css("height", selfScope.currentWindowHeight);
				} else {
					dom.headerMenu.css("height", "");
				}
			},

			/**
			 * Add or remove a class to the body, based on whether or not the sidemenu (main menu) is open.
			 */
			handleSideMenuActivation: function () {
				var isChecked = helpers.setScrolllockDependingOnCheckboxState(dom.sideMenuToggleCheckbox, true);
				dom.headerMenu.attr("aria-hidden", isChecked ? "false" : "true");
			},

			/**
			 * This function forces all sibling menus to close when an item is toggled (either on or off). This ensures
			 * that only one menu may be opened per level at any time. Sadly there's no way to handle this in CSS, or I
			 * would have.
			 */
			handleCheckboxSelectionInMainMenu: function () {
				var element = $(this),
					parent = element.parent();

				parent.siblings().find(":checkbox").prop("checked", false);

				// Too bad this is necessary, but there seems to be no other way.
				if (document.documentMode && document.documentMode === 11) {
					selfScope.fixMenuItemsInIE11();
				}
			}

		};


		/**
		 * Force IE11 to re-render main menu items; fixing their height in the process. This is to get around
		 * a rendering error in the browser engine that I can't seem to fix any other way. So sad. So sad. It's
		 * a sad, sad situation.
		 */
		this.fixMenuItemsInIE11 = function () {
			if (!menuItemsInMainMenu) {
				menuItemsInMainMenu = dom.container.find("li");
			}

			menuItemsInMainMenu.css("height", "auto");
			window.setTimeout(function () {
				menuItemsInMainMenu.css("height", "");
			}, 500);
		};


		/**
		 * Initialization function, which is run when the module is "booting".
		 */
		function init() {

			dom.container = $(configuration.container);

			if (dom.container.length) {

				// We'll set up the scroll handler to be bound a second later than the rest. This prevents the page
				// from hiding the menu before it's time.
				window.setTimeout(function () {
					selfScope.onScroll(eventHandlers.onScrollEvent);
				}, 1000);

				// Set up some events for our main menu.
				dom.headerMenu = $("#headerMenu");
				dom.headerMenu.find(":checkbox").click(eventHandlers.handleCheckboxSelectionInMainMenu);
				if (!Modernizr.cssvhunit || selfScope.isMobileSafari) {
					selfScope.onWindowResize(eventHandlers.fixSidemenuHeight);
					eventHandlers.fixSidemenuHeight();
				}

				// Handle "clicks" on the menu toggle checkbox
				dom.sideMenuToggleCheckbox = dom.container.find("#sideMenuActive");
				dom.sideMenuToggleCheckbox.click(eventHandlers.handleSideMenuActivation);
				eventHandlers.handleSideMenuActivation();


				initComplete = true;
			}


		}

		// Once everything is ready, run the init-function to get the ball rolling. The "onReady()" function lives
		// in dis.base.js.
		selfScope.onReady(init);

	};

	dis.ui.Header.prototype = new dis.BaseModule();
	dis.ui.Header.constructor = dis.ui.Header;

}(jQuery, dis));